<template>
        <Secao titulo="local" id="local">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7653.643937386788!2d-51.12854228318527!3d-16.43386572650441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9366bda5b0698455%3A0x35bb6586539d169!2sInstituto%20Federal%20Goiano%20-%20Campus%20Ipor%C3%A1!5e0!3m2!1spt-BR!2sbr!4v1649179898052!5m2!1spt-BR!2sbr"
        width="100%"
        height="450"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>

      <div class="row mt-5 mb-5">
        <div class="col-md-3 d-flex align-items-center justify-content-center">
          <b class="text-center"
            ><i class="lni lni-map-marker" style="font-size: 50px"></i
          ></b>
        </div>
        <div class="col-md-3">
          <p class="laranja"><b>onde acontece</b></p>
          <p>Instituto Federal Goiano<br />Campus Iporá<br />Unidade Sede</p>
        </div>
        <div class="col-md-3">
          <p class="laranja"><b>endereço</b></p>
          <p>Avenida Oeste, 350<br />Parque União<br />Iporá - GO</p>
        </div>
        <div class="col-md-3">
          <p class="laranja"><b>sobre</b></p>
          <p>Hospedagem</p>
          <p>Alojamento</p>
        </div>
      </div>
    </Secao>
</template>

<script>
import Secao from "../layout/Secao.vue";

export default {
  name: "App",
  components: {
    Secao,
  },
};
</script>

<style lang="scss" scoped>
section#local {
	background: #fff;
	color: #fff;
	background-image: linear-gradient(180deg, transparent 50%, var(--corFundoIntercalado) 50%);
	iframe {
		border-radius: 20px;
		box-shadow: 0 5px 20px -10px rgba(69,67,96,0.25);
	}
}
</style>